<template>
	<div>
		<common-header navbar-index=4></common-header>
		<cpp-banner></cpp-banner>
		<test-chapter></test-chapter>
		<test-content></test-content>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import CppBanner from '@/pages/cpp/components/CppBanner'
	import TestChapter from '@/pages/cpp/components/TestChapter'
	import TestContent from '@/pages/cpp/components/TestContent'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'RobotDesc',
		components: {
			CommonHeader,
			CppBanner,
			TestChapter,
			TestContent,
			CommonFooter
		},
		data() {
			return {
				testContentList: []
			}
		},
		methods: {
			
		},
		mounted() {
			
		}
	};
</script>

<style lang="scss" scoped>

</style>